import { PDFFieldData } from "./FieldTypes/PDFFieldData";
import { PDFKeyValuePair } from "./FieldTypes/IFormField";

class FormValue {
    Key: string;
    Value: string | PDFFieldData | Blob | Blob[] | PDFKeyValuePair | (string | PDFKeyValuePair)[] | number | null;

    constructor(key: string, value: string | PDFFieldData | Blob | Blob[] | PDFKeyValuePair | (string | PDFKeyValuePair)[] | number | null) {
        this.Key = key;
        this.Value = value;
    }
}

export { FormValue }
